import React, { useState, useEffect } from 'react';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { clearError } from '../../store/slices/formconfig';

interface ErrorModalProps {
   
    errorMessage: string;
   
    isVisible: boolean;
   
    onClose: () => void;
}


const ErrorIcon = () => (
    <span style={{ fontSize: '24px', color: '#ff4d4f', marginRight: '10px' }}>
        &#9888;
    </span>
);

const ErrorModal = () => {

    const dispatch = useDispatch();

const errorState = useSelector((state: any) => state.formConfig);




    useEffect(() => {
        const handleKeyDown = (event:any) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

      
        document.addEventListener('keydown', handleKeyDown);

        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [errorState.errorVisible]);
   
    if (!errorState.errorVisible) {
        return null;
    }

   
    const handleClose = () => {
       
        dispatch(clearError());
    };

    
    


    return (
       
        <div className="modal-backdrop">
            
            <div className="error-modal-content" role="alert" aria-modal="true">
                
               
                <button 
                    className="modal-close-button" 
                    onClick={handleClose}
                    aria-label="Close error message"
                >
                    &times;
                </button>

              
                <div className="modal-header" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <ErrorIcon />
                    <h2>Error Occurred</h2>
                </div>

               
                <div className="modal-body" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <p style={{textAlign:'center'}}>{errorState.errorMessage?errorState.errorMessage:'An error occurred. Please try again.'}</p>
                </div>

              
                <div className="modal-footer" style={{justifyContent:'center'}}>
                    <button className="modal-ok-button" onClick={handleClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;